var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Sidebar',{staticStyle:{"height":"100vh","position":"fixed","z-index":"10"}}),_vm._v(" "),_c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.getPageTitle(_vm.$route.meta.title)),expression:"getPageTitle($route.meta.title)"}],staticClass:"content"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-004b38c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/index.vue
// module id = null
// module chunks = 